import React from 'react'
import { BoxProps, Image } from 'rebass'
import { imageStyles } from './styles'

export interface FImageProps extends BoxProps {
    imageUrl: string
    alt: string
    width?: number[] | string
    height?: number[] | string
}

const FImage = (props: FImageProps) => {
    const { width = imageStyles.desktop.defaultWidth, height = imageStyles.desktop.defaultHeight } = props

    return (
        <React.Fragment>
            <Image
                src={`${props.imageUrl}`}
                {...props}
                alt={props.alt}
                width={width}
                height={height}
                style={{ objectFit: 'contain' }}
            />
        </React.Fragment>
    )
}

export default FImage
